export default "__VITE_ASSET__DBVUXB5G__"